import { EEndpoint } from '../../config/endpoint.config';
import { AxiosResponse } from 'axios';
import { IEntity } from '../../domain/entity.interface';
import { HttpService } from '../../services/services.index';
import {
  IContactResume,
  IContactComplete,
  IContactInvited,
} from '../../domain/contact.interface';

export const GET_USERS = 'GET_USERS';
export const RESET_USERS = 'RESET_USERS';
export const GET_CONTACTS = 'GET_CONTACTS';
export const RESET_CONTACTS = 'RESET_CONTACTS';

const httpService = new HttpService();

export const getUsers = (query: string) => {
  return (dispatch: any) => {
    httpService
      .get(EEndpoint.GET_USERS, { params: { pattern: query }, silently: true })
      .then((res: AxiosResponse<IEntity[]>) => {
        dispatch({
          type: GET_USERS,
          payload: res,
        });
      });
  };
};

export const getContacts = () => {
  return (dispatch: any) => {
    httpService
      .get(EEndpoint.GET_CONTACTS)
      .then((res: AxiosResponse<IContactComplete[]>) => {
        dispatch({
          type: GET_CONTACTS,
          payload: res,
        });
      });
  };
};

export const addContact = (body: IContactResume, id: string) => {
  const { alias, comments } = body;
  const birthday = new Date(Date.parse(body['birthday'] as any));
  return (dispatch: any) => {
    httpService
      .post(EEndpoint.GET_CONTACTS, {
        userId: id,
        alias: alias,
        birthday: birthday,
        comments: comments,
      })
      .then((res: any) => {
        dispatch(getContacts());
      });
  };
};

export const editContact = (body: IContactResume, contactId: string) => {
  const { alias, comments } = body;
  const birthday = new Date(Date.parse(body['birthday'] as any));
  return (dispatch: any) => {
    httpService
      .put(
        EEndpoint.CONTACT_ID,
        {
          alias: alias,
          birthday: birthday,
          comments: comments,
        },
        { params: { contactId: contactId } },
      )
      .then((res: any) => {
        dispatch(getContacts());
      });
  };
};

export const deleteContact = (contactId: any) => {
  return (dispatch: any) => {
    httpService
      .delete(EEndpoint.CONTACT_ID, { params: { contactId: contactId } })
      .then(() => {
        dispatch(getContacts());
      });
  };
};

export const inviteContacts = (body: IContactInvited) => {
  return async (dispatch: any) => {
    await httpService.post(EEndpoint.INVITE_CONTACTS, body);
    dispatch(getContacts());
  };
};

export const resetUsers = () => {
  return {
    type: RESET_USERS,
  };
};
